import { defineType } from 'sanity';

export const team = defineType({
    name: 'team',
    title: 'Team section',
    type: 'object',
    fields: [
        {
            name: 'title',
            title: 'Title',
            type: 'localizedString',
        },
        {
            name: 'description',
            title: 'Description',
            type: 'localizedText',
        },
        {
            name: 'members',
            title: 'Team Members',
            type: 'array',
            of: [
                {
                    type: 'object',
                    fields: [
                        {
                            name: 'name',
                            title: 'Name',
                            type: 'localizedString',
                        },
                        {
                            name: 'role',
                            title: 'Role',
                            type: 'localizedString',
                        },
                        {
                            name: 'bio',
                            title: 'Biography',
                            type: 'localizedString',
                        },
                        {
                            name: 'image',
                            title: 'Photo',
                            type: 'seoOptimizedImageUrl',
                        },
                    ],
                },
            ],
        },
        {
            name: 'variant',
            title: 'Variant',
            type: 'string',
            options: {
                list: [
                    { title: 'Variant A', value: 'A' },
                    { title: 'Variant B', value: 'B' },
                    { title: 'Variant C', value: 'C' },
                ],
            },
        },
    ],
    preview: {
        select: {
            title: 'title',
        },
        prepare({ title }) {
            return {
                title: `Team Section: ${title['en'] || title['sr']}`,
            };
        },
    },
});
